import { Button, Flex, Input, Modal, Space } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { LoaderBox } from "src/components/LoaderBox";

import { QueryBuilderStore } from "../../QueryBuilderStore";
import { GroupItem } from "../GroupItem/GroupItem";
import * as styles from "./QueryBuilderModal.module.less";

type PropsQueryBuilderModal = {
  open: boolean;
  store: QueryBuilderStore;
  onCancel: () => void;
  onReset: () => void;
  onResetConditions: () => void;
  onApply: () => void;
  onSaveTemplate?: () => void;
  onChooseTemplate?: () => void;
  canSaveTemplate?: boolean;
};

export const QueryBuilderModal: React.FC<PropsQueryBuilderModal> = observer(
  ({
    open,
    store,
    onCancel,
    onReset,
    onResetConditions,
    onApply,
    onSaveTemplate,
    onChooseTemplate,
    canSaveTemplate = true,
  }) => (
    <Modal
      zIndex={800}
      title="Конструктор фильтра"
      open={open}
      onCancel={onCancel}
      width="calc(100vw - 144px)"
      style={{ top: 64, paddingBottom: 0 }}
      closable
      styles={{
        content: {
          height: "calc(100vh - 128px)",
          display: "flex",
          flexDirection: "column",
        },
        body: { flex: 1, minHeight: 0, overflowY: "auto" },
      }}
      footer={
        <Flex justify="space-between" align="center" style={{ width: "100%" }}>
          <Button key="reset" onClick={onReset}>
            Сбросить фильтр
          </Button>

          <Flex gap={8}>
            <Button
              key="save-template"
              onClick={onSaveTemplate}
              disabled={!onSaveTemplate || !canSaveTemplate}
            >
              Сохранить шаблон
            </Button>
            <Button key="apply" type="primary" onClick={onApply}>
              Применить
            </Button>
          </Flex>
        </Flex>
      }
    >
      <LoaderBox
        remoteData={store.data}
        drawReady={() => (
          <Inner
            store={store}
            onResetConditions={onResetConditions}
            onChooseTemplate={onChooseTemplate}
          />
        )}
      />
    </Modal>
  ),
);

type PropsInner = {
  store: QueryBuilderStore;
  onResetConditions: () => void;
  onChooseTemplate?: () => void;
};

const Inner: React.FC<PropsInner> = observer(
  ({ store, onResetConditions, onChooseTemplate }) => {
    const { draftStore } = store;
    const nameErrorMessage = draftStore.nameValidationErrorMessage;
    const showNameError = draftStore.shouldShowNameValidationError;

    return (
      <div className={styles.queryBuilder}>
        <div className={styles.queryBuilderMeta}>
          <div className={styles.sectionTitle}>Название</div>
          <Input
            value={draftStore.templateName}
            onChange={(e) => draftStore.setTemplateName(e.target.value)}
            placeholder="Введите название"
            status={showNameError ? "error" : undefined}
          />
          {showNameError && (
            <div className={styles.errorText}>{nameErrorMessage}</div>
          )}
        </div>

        <div className={styles.queryBuilderToolbar}>
          <div className={styles.sectionTitle}>Условия</div>
          <Space size="small">
            <Button onClick={onResetConditions} size="small">
              Сбросить все условия
            </Button>
            <Button
              size="small"
              onClick={onChooseTemplate}
              disabled={!onChooseTemplate}
            >
              Выбрать шаблон
            </Button>
          </Space>
        </div>

        <GroupItem
          group={store.rootGroup}
          path={[]}
          store={store}
          depth={0}
          canDelete={false}
        />
      </div>
    );
  },
);
